export default __webpack_public_path__ + "static/clients-c53377e6be55b845df82684a41eb27d4.png";